import apiClient from './authService';

export const tenantService = {
  getMe: async () => {
    const response = await apiClient.get('/api/tenants/me');
    return response.data;
  },

  getAllTenants: async () => {
    const response = await apiClient.get('/api/tenants');
    return response.data;
  },

  getTenant: async (id) => {
    const response = await apiClient.get(`/api/tenants/${id}`);
    return response.data;
  },

  createTenant: async (tenantData) => {
    const response = await apiClient.post('/api/tenants', tenantData);
    return response.data;
  },

  updateTenant: async (id, tenantData) => {
    const response = await apiClient.put(`/api/tenants/${id}`, tenantData);
    return response.data;
  },

  deleteTenant: async (id) => {
    const response = await apiClient.delete(`/api/tenants/${id}`);
    return response.data;
  },

  inviteTenant: async (id) => {
    const response = await apiClient.post(`/api/tenants/${id}/invite`);
    return response.data;
  }
};
